// The amount of currency in cents. A cent is 1/100 of a full currency even if the currency
// doesn't have the traditional notion of cents.
export const convertToDollars = (amount?: number) => {
  if (typeof amount === 'number') {
    return amount / 100;
  }
};
